import { useState, useEffect, useContext } from 'react';
import { Card, Chip, Typography, TextField, Grid, Button, Box, Tooltip, IconButton, Modal, InputAdornment, Skeleton, Switch, useTheme, useMediaQuery, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Swal from 'sweetalert2';
import { DataGrid, } from '@mui/x-data-grid';
import { useForm, Controller } from 'react-hook-form';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import { useNavigate } from 'react-router-dom';
import { Helpers } from '../../../services/Helpers';
import { PermissionGuard } from '../../../components/PermissionGuard';
import {  Delete, Edit, Restore, Search } from '@mui/icons-material';
import Loading from '../../../components/Loader/Loading';
// import Filter from './filterAndExport/Filter';
import { LocalStore } from '../../../storage/authStore';
import noImage from '../../../assets/images/no_image_available.png'
import { EventServices } from './EventServices';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import useResponsive from '../../../hooks/useResponsive';
import { usePermission } from '../../../hooks/usePermission';
import { EventContext } from '.';
export default function EventList() {
    const { eventInitialData,eventData,setEventData,fetchEventList,eventList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedEventData, setSelectedEventData} = useContext(EventContext);
    
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const loggedUser = LocalStore.getLoggedUserDetails();
    const {isSm} = useResponsive();
    const userPermissions = usePermission("brand");
    const showActionColumn = userPermissions.canEdit;
    // console.log('loggedUser', loggedUser);
    const navigate = useNavigate();
    const { control, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
          searchKey: "",
        }
    });
    
    // const [deleteRowData, setDeleteRowData] = useState({});

   /************************  Manage Use Effect **************************** */
    useEffect(() => {
        fetchEventList();
    }, [paginationModel]);    

    const handleStatusChange = async (brand) => {
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: `You want to change the status form ${brand.isActive ? 'Active' : 'In-Active'} to ${brand.isActive ? 'In-Active' : 'Active'} of this service!`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, change it!',
          cancelButtonText: 'No, keep it'
        });
        if (result.isConfirmed) {
          // processing screen 
          Swal.fire({
            title: 'Processing',
            html: 'Please wait...',
            didOpen: () => {
              Swal.showLoading();
            },
          });
          const modifiedData = {
            title:brand.title,
            image:brand.image,
            bLevel:brand.bLevel,
            isActive: !brand.isActive
          }
          try {
            const response = await EventServices.updateBrand(modifiedData,brand.id);
            if (response.success == '1') {
              Swal.fire('Status Changed!', '', 'success');
              // setDeleteRowData(response.data);
            } else {
              Swal.fire('Failed!', '', 'error');
            }
          } catch (error) {
            Swal.fire('Failed!', '', 'error');
          }
        }
    }
    const handleRestore = async (id) =>{
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: `You want to restore this service!`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, restore it!',
          cancelButtonText: 'No, keep it'
        });
        if (result.isConfirmed) {
          // processing screen 
          Swal.fire({
            title: 'Processing',
            html: 'Please wait...',
            didOpen: () => {
              Swal.showLoading();
            },
          });
          try {
            const response = await EventServices.restoreEvent(id);
            if (response.success == '1') {
              Swal.fire({
                title: 'Restored!',
                text: "Event has been restored.",
                icon: 'success',
                showConfirmButton: false,
                timer: 1500
              });
              fetchEventList();
            } else {
              Swal.fire('Failed!', '', 'error');
            }
          } catch (error) {
            Swal.fire('Failed!', '', 'error');
          }
        }
    }
    
      
    /************************  Table Column Manage **************************** */
    const columns = [
      {
        field: 'id',headerName:' S.No. ',headerAlign:'center',flex:0.5,
        renderCell: (params) => (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#3e3e3e', textAlign: 'center', fontSize: '.7rem' }}>{paginationModel.page * paginationModel.pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id)+1}</Typography>
          </Box>
        ),
      },
      {
        field: 'title',
        headerName: 'Event',
        headerAlign: 'center',
        flex: 2,
        // sortable: false,
        // filterable: false,
        valueGetter: (params) => {
          // Join all subcategory titles into a single searchable string
          const parentServiceTitle = params.row.parentServiceId > 0 && params.row.parentService?.title || '';
          const title = params.row.title;
          return parentServiceTitle ? `${title} (${parentServiceTitle})` : title;
        },
        renderCell: (params) => (
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            {/* <Box sx={{ width: '15%' }}>
              {params.row.image ? (
                <img
                  //   src={params.row.image} 
                  src={`${Helpers.ImagePathUrl()}/brands/sm/${params.row.image}`}
                  alt={params.row.title}
                  style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
                />
              ) : (
                // <Skeleton variant="rectangular" width={35} height={35} animation={false} />
                <img
                  //   src={params.row.images} 
                  src={noImage}
                  alt={params.row.title+'image_not_available'}
                  style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
                />
              )}
            </Box> */}
            <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} sx={{ ml: 1, width: '85%' }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: '#3e3e3e', textAlign: 'center', fontSize: '.7rem' }}>{params.row.title}
              </Typography>
            </Box>
          </Box>
        ),
      },
      {
        field: 'status',
        headerName: 'Status',
        headerAlign: 'center',
        flex: 1,
        sortable: false,
        renderCell: (params) => (
          <Box sx={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            
            <Chip
              label={params.row?.deletedAt ? 'Deleted' : 'Active'}
              color={params.row?.deletedAt ? 'error' : 'success'}
              size="small"
              sx={{ fontSize: '0.65rem', height: 'fit-content' }}
            />
          </Box>
        ),
      },
      {
        field: 'actions',
        headerName: 'Actions',
        headerAlign: 'center',
        flex: 1,
        filterable: false,
        sortable: false,
        renderCell: (params) => (
          <Box sx={{ p: 1, display: 'flex', gap: 1, justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            {/* <IconButton
              sx={{ color: "blue", }}
              // onClick={() => modalOpen(params.row,'view')} 
              onClick={(e) => window.open(`/admin/service-details/${params.row.id}`, '_blank')}
              size="small">
              <RemoveRedEyeIcon sx={{ fontSize: '0.95rem' }} />
            </IconButton> */}
            <PermissionGuard feature='service' permission='canEdit'>
              <IconButton
                  disabled={selectedEventData}
                  onClick={() => setSelectedEventData(params.row)}
                  size="small" color='warning'
              >
                <Edit sx={{ fontSize: '0.95rem' }} />
              </IconButton>
            </PermissionGuard>
            <PermissionGuard feature='service' permission='canEdit'>
              {params.row?.deletedAt && <IconButton
                  disabled={selectedEventData}
                  onClick={() => handleRestore(params.row.id)}
                  size="small" color='success'
              >
                <Restore sx={{ fontSize: '0.95rem' }} />
              </IconButton>}
            </PermissionGuard>
            <PermissionGuard feature='service' permission='canDelete'>
              {!params.row?.deletedAt && <IconButton 
                onClick={() => handleDelete(params.row.id)} 
                color="error"
                size="small"
              >
                  <Delete sx={{ fontSize: '0.95rem' }} />
              </IconButton>}
            </PermissionGuard>
          </Box>
        ),
      },
    ];
    /************************  Action Handler Related table row **************************** */
    const handlePaginationChange = (newPagination) => {
        setPaginationModel({
          ...paginationModel,
          page: newPagination.page,
          pageSize: newPagination.pageSize
        });
    }

    function onSubmit(data) {
        const filtersData = getValues();
        setPaginationModel({
          ...paginationModel,
          filters: {
            ...paginationModel.filters,
            searchKey: filtersData.searchKey,
          }
        });
    }

    const clearFilters = () => {
        reset({
          searchKey: "",
        });
        setPaginationModel({
          ...paginationModel,
          filters: {
            ...paginationModel.filters,
            searchKey: "",
            sortBy: 'createdAt',
            sortType: 'desc',
            filterOptions: []
          }
        });
    
        // Trigger clear for MultiColumnFilter
        setClearMultiFilter(true);
    
        // Reset the clear trigger after a short delay
        setTimeout(() => setClearMultiFilter(false), 100);
    }

    /************************  Advance Filter **************************** */


    const [clearMultiFilter, setClearMultiFilter] = useState(false);
    
    const handleApplyFilter = (filterData) => {
        // Process filter data
        console.log(filterData);
        setPaginationModel({
          ...paginationModel,
          page: 0, // Reset to first page when applying new filters
          filters: {
            ...paginationModel.filters,
            // Convert MultiColumnFilter options to a format your backend can understand
            filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
          }
        });
    }
    
    /************* quick search related **************/
    // Properly structured filter model
    const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterValues: []
    });

    /******************* Sorting model  ******************************/
    const [sortModel, setSortModel] = useState([
        {
          field: paginationModel.filters.sortBy,
          sort: paginationModel.filters.sortType,
        },
    ]);
    
    const handleSortingChange = (newSortModel) => {
        if (newSortModel && newSortModel.length > 0) {
          setSortModel(newSortModel);
          setPaginationModel(prev => ({
            ...prev,
            filters: {
              ...prev.filters,
              sortBy: newSortModel[0].field,
              sortType: newSortModel[0].sort
            }
          }));
        }
    }
    const filterableColumns = [
      {
        key: 'title',
        label: 'Event Name',
        type: 'text'
      },
      
      {
        key: 'deletedAt',
        label: 'Status',
        type: 'select',
        options: [
            { value: 'null', label: 'Active' },
            { value: 'true', label: 'Deleted' },
        ]
      }
    ];
    const handleDelete = async(id) => {
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
          allowEscapeKey: false,
          allowOutsideClick: false
        });
        if (result.isConfirmed) {
          // processing screen 
          Swal.fire({
            title: 'Processing',
            html: 'Please wait...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          try {
            const response = await EventServices.deleteEvent(id);
            if (response.success == '1') {
              Swal.fire({
                title: 'Deleted!',
                text: "Event has been deleted.",
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
              });
              fetchEventList();
              // setDeleteRowData(response.data);
            } else {
              Swal.fire('Failed!', '', 'error');
            }
          } catch (error) {
            Swal.fire('Failed!', '', 'error');
          }
        }
    }
    return (
      <>
          
          {/* =================== Searching and sorting section ================== */}
          <Card sx={{ minWidth: "100%", marginBottom: ".5%"}}>
            <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
                <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >Event List</Typography>
            </Box>
            <Box sx={{ overflow: "auto" }}>
                {loadingList && <Loading />}
                <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                    <MultiColumnFilter
                        filterableColumns={filterableColumns}
                        onApplyFilter={handleApplyFilter}
                        externalClear={clearMultiFilter}
                        defaultFilterOptions={paginationModel.filters.filterOptions}
                    />
                    {/* <ExportAll 
                        paginationModel={paginationModel} 
                        // columns={columns} 
                        // statusOptions={statusOptions} 
                    /> */}
                    </Box>
                    <Box sx={{display:{xs:'none',sm:'block'}}}>
                        {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
                        <Grid container spacing={1} sx={{ p: '1%' }} component={'form'} onSubmit={handleSubmit(onSubmit)}>
                            <Grid item xs={9} lg={8}>
                                <Controller
                                name="searchKey"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                    {...field}
                                    placeholder="Search here....."
                                    // label="Search"
                                    size="small"
                                    fullWidth
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                        paddingLeft: '0px',
                                        }
                                    }}
                                    InputProps={{  // Changed from slotProps to InputProps
                                        inputProps: {
                                        style: {
                                            height: '0.6rem',
                                            textTransform: 'uppercase',
                                            fontSize: 'x-small'
                                        },
                                        },
                                        startAdornment: (
                                        <InputAdornment position="start">
                                            <IconButton>
                                            <Search sx={{ fontSize: 'x-small' }} />
                                            </IconButton>
                                        </InputAdornment>
                                        ),
                                    }}
                                    />
                                )}
                                />
                            </Grid>
                            <Grid item xs={3} sm={4} >
                                <Tooltip title="Search" sx={{ ml: 1, p: 0 }}>
                                <IconButton
                                    size='small'
                                    color="primary"
                                    type="submit"
                                    sx={{ border: "1px solid", borderRadius: "7px", padding: "1%", ml: 1 }}
                                >
                                    <SearchIcon sx={{ fontSize: '.85rem' }} />
                                </IconButton>
                                </Tooltip>
                                <Tooltip title="Clear All Filters">
                                <IconButton
                                    size='small'
                                    color="primary"
                                    sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: "1%" }}
                                    onClick={clearFilters}
                                >
                                    <RestartAltIcon sx={{ fontSize: '.85rem' }} />
                                </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <DataGrid
                    rows={eventList}
                    columns={columns.map((col) => ({
                    ...col,
                    // flex: col.flex || 1, // Ensure columns resize dynamically
                    minWidth: isSmallScreen && (col.minWidth || 150), // Set a minimum width to avoid overlap
                    }))}
                    getRowId={(row) => row.id}
                    //checkboxSelection={true}
                    rowCount={totalRowCount}  // Use the length of the filtered list
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={handlePaginationChange}

                    filterModel={filterModel}

                    sortingMode="server"
                    sortModel={sortModel}
                    onSortModelChange={handleSortingChange}
                    sortingOrder={['asc', 'desc']}

                    loading={loadingList}

                    disableColumnMenu
                    disableRowSelectionOnClick
                    slots={{
                    // toolbar: GridToolbar,                        
                    loadingOverlay: Loading,
                    noRowsOverlay: NoRowsLayout,
                    }}
                    autoHeight
                    getRowHeight={() => 'auto'}
                    sx={{
                    '& .MuiDataGrid-cell': {
                        border: 1,
                        borderRight: 0,
                        borderTop: 0,
                        borderColor: 'lightgrey',
                        display: 'flex',
                        alignItems: 'center',
                        // justifyContent: 'center',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                        borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p: 0,
                        height: 'fit-content',
                        minHeight: '0 !important',
                        height: '2rem'
                    },
                    '& .MuiDataGrid-columnHeader': {
                        borderLeft: '1px solid rgba(224, 224, 224, 1)',
                        '&:last-child': {
                        borderRight: 'none',
                        },
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 600,
                        color: '#3e3e3e'
                    },
                    '& .MuiDataGrid-row': {
                        '&:last-child .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        },
                        '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                        },
                    },
                    '& .MuiDataGrid-columnSeparator': {
                        display: 'none',
                    },
                    }}
                />
                </Box>
            </Box>
          </Card>
      </>
    )
}